import { render, staticRenderFns } from "./MenuProduct.vue?vue&type=template&id=37c5de12&scoped=true&"
import script from "./MenuProduct.vue?vue&type=script&lang=js&"
export * from "./MenuProduct.vue?vue&type=script&lang=js&"
import style0 from "./MenuProduct.vue?vue&type=style&index=0&id=37c5de12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c5de12",
  null
  
)

export default component.exports